<template>
  <tr class="documents-slot-row" data-testid="documents-slot-row">
    <!-- Slot type (for operation documents) -->
    <td v-if="showSlot" class="text-no-wrap py-2">
      <div class="d-flex align-center min-w-0">
        <v-chip
          v-if="document.doctype"
          x-small
          :color="isInvoice ? 'primaryTransp' : undefined"
          :text-color="isInvoice ? 'primary' : undefined"
          :outlined="!isInvoice"
          class="font-weight-medium slot-chip"
        >
          <span class="text-truncate" :title="slotLabel">{{ slotLabel }}</span>
        </v-chip>
        <span v-else class="grey--text">-</span>
      </div>
    </td>

    <!-- Filename -->
    <td class="py-2 min-w-0">
      <div class="d-flex align-center min-w-0">
        <v-icon small color="red lighten-2" class="mr-2 flex-shrink-0">mdi-file-pdf-box</v-icon>
        <span class="documents-slot-row__name text-truncate flex-grow-1" :title="document.filename">
          {{ document.filename || '-' }}
        </span>
      </div>
    </td>

    <!-- Upload date -->
    <td class="text-no-wrap py-2">
      <date-time-layout :timestamp="document.timestamp" />
    </td>

    <!-- Size -->
    <td class="text-no-wrap py-2 grey--text text--lighten-1">{{ formattedSize }}</td>

    <!-- Download action -->
    <td class="text-right py-2">
      <v-btn
        icon
        small
        class="download-btn"
        :loading="downloading"
        :disabled="downloading"
        :title="$t('documents.download')"
        data-testid="documents-download"
        @click="$emit('download', document)"
      >
        <v-icon small color="primary">mdi-download</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import DateTimeLayout from '@/components/common/DateTimeLayout.vue'
import { formatFileSize } from './documentHelpers.js'

const SLOT_LABEL_KEYS = {
  invoice:            'invoice',
  import_declaration: 'importDeclaration',
  proof_of_import:    'proofOfImport',
  bill_of_lading:     'billOfLading',
}

export default {
  name: 'DocumentsSlotRow',

  components: { DateTimeLayout },

  props: {
    // One upload: filename, timestamp, size, sha256, and doctype for operations.
    document:    { type: Object, required: true },
    downloading: { type: Boolean, default: false },
    showSlot:    { type: Boolean, default: false },
  },

  emits: ['download'],

  computed: {
    isInvoice () {
      return this.document.doctype === 'invoice'
    },
    formattedSize () {
      return formatFileSize(this.document.size)
    },
    slotLabel () {
      const key = SLOT_LABEL_KEYS[this.document.doctype]
      if (!key) return String(this.document.doctype || '').replace(/_/g, ' ')
      return this.$t(`instructions.uploadFiles.typesOfDocumentation.${key}`)
    },
  },
}
</script>

<style scoped lang="scss">
.documents-slot-row {
  transition: background 0.15s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }
}

.min-w-0 {
  min-width: 0 !important;
}

.documents-slot-row__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.85rem;
}

.slot-chip {
  max-width: 100%;
}

.download-btn {
  &:hover {
    background: rgba(0, 115, 255, 0.15) !important;
  }
}
</style>
